/*
 * Lista de espera do site novo Burst (design do Faustino no Paper).
 * Spec: _ferramentas/specs/2026-10-07-prelancamento-sleep-design.md, seção 5.
 * A parte pura (telefone, validação, payload, respostas do CRM, envios) é exportada para os testes
 * em Node; a parte de tela (iniciar) roda só no navegador.
 */
(function (raiz, fabrica) {
  var api = fabrica(raiz);
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    raiz.BstListaEspera = api;
  }
})(typeof self !== 'undefined' ? self : this, function (raiz) {
  'use strict';

  var UTMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  /* ---------- telefone: mesma regra do CRM (app/Support/BrazilianPhone.php) ---------- */

  function digitosNacionais(bruto) {
    var d = String(bruto == null ? '' : bruto).replace(/\D+/g, '');
    if (d.length > 1 && d.charAt(0) === '0') d = d.slice(1);
    if ((d.length === 12 || d.length === 13) && d.slice(0, 2) === '55') d = d.slice(2);
    return d;
  }

  function normalizarTelefone(bruto) {
    var d = digitosNacionais(bruto);
    var ddd = d.slice(0, 2);
    var assinante = d.slice(2);
    if (!/^[1-9][1-9]$/.test(ddd)) return null;
    if (assinante.length === 8) {
      var primeiro = Number(assinante.charAt(0));
      if (primeiro >= 6) return '+55' + ddd + '9' + assinante;
      if (primeiro >= 2) return '+55' + ddd + assinante;
      return null;
    }
    if (assinante.length === 9) {
      return assinante.charAt(0) === '9' ? '+55' + ddd + assinante : null;
    }
    return null;
  }

  function mascarar(d) {
    if (d.length <= 2) return '(' + d;
    var ddd = d.slice(0, 2);
    var resto = d.slice(2);
    if (resto.length <= 4) return '(' + ddd + ') ' + resto;
    var corte = resto.length === 9 ? 5 : 4;
    return '(' + ddd + ') ' + resto.slice(0, corte) + '-' + resto.slice(corte);
  }

  // Máscara enquanto digita: "(11) 98765-4321" ou "(11) 3456-7890". Só apresenta dígitos: tira o DDI
  // "+55" e, como o CRM, um 0 de tronco. Garantia por construção: a máscara NUNCA muda o número que o
  // CRM entenderia — se mudaria (dígitos demais, 0 duplo, colagem por cima), o campo mostra só os
  // dígitos crus e a validação acusa. Cortar ou reinterpretar fazia o número de outra pessoa.
  function formatarTelefone(bruto) {
    var texto = String(bruto == null ? '' : bruto).trim();
    var digitos = texto.replace(/\D+/g, '');
    var d;
    if (texto.charAt(0) === '+') {
      d = digitos;
      if (d.slice(0, 2) === '55') d = d.slice(2);
    } else {
      d = digitosNacionais(texto);
    }
    if (!d) return '';
    if (d.length > 11) return digitos;
    var mascarado = mascarar(d);
    var numero = normalizarTelefone(mascarado);
    if (numero !== null && numero !== normalizarTelefone(texto)) return digitos;
    return mascarado;
  }

  /* ---------- outros campos ---------- */

  // Mais estrita que o CRM (FILTER_VALIDATE_EMAIL do PHP): tudo o que passa aqui o CRM aceita —
  // senão ele grava o e-mail como vazio sem avisar e o aviso de abertura não chega. Só ASCII; usuário
  // sem ponto na ponta nem ponto duplo; domínio em rótulos [a-z0-9-] sem hífen na ponta; final só letras.
  var RE_EMAIL = /^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

  function emailValido(email) {
    return RE_EMAIL.test(String(email == null ? '' : email).trim());
  }

  function nomeValido(nome) {
    var letras = String(nome == null ? '' : nome).match(/[A-Za-zÀ-ÖØ-öø-ÿ]/g);
    return !!letras && letras.length >= 2;
  }

  function separarNome(nome) {
    var partes = String(nome == null ? '' : nome).trim().split(/\s+/).filter(Boolean);
    return { primeiro: partes[0] || '', resto: partes.slice(1).join(' ') };
  }

  function primeiroNome(nome) {
    var p = separarNome(nome).primeiro;
    return p ? p.charAt(0).toUpperCase() + p.slice(1) : '';
  }

  /* ---------- payload do CRM ---------- */

  function lerUtms(busca) {
    var saida = {};
    var params = new URLSearchParams(String(busca || '').replace(/^\?/, ''));
    UTMS.forEach(function (chave) {
      var valor = params.get(chave);
      if (valor) saida[chave] = valor.slice(0, 200);
    });
    return saida;
  }

  function montarPayload(dados, config, local) {
    var payload = {
      name: String(dados.nome || '').trim().replace(/\s+/g, ' ').slice(0, 160),
      email: String(dados.email || '').trim().toLowerCase().slice(0, 160),
      phone: normalizarTelefone(dados.whatsapp),
      source: config.origem || 'pre-lancamento-sleep',
      page_url: String((local && local.href) || '').slice(0, 1000),
      consentimento: String(config.consentimento || '').trim()
    };
    var utms = lerUtms(local && local.search);
    Object.keys(utms).forEach(function (chave) { payload[chave] = utms[chave]; });
    return payload;
  }

  /* ---------- respostas do CRM (spec, seção 5) ---------- */

  function classificarResposta(status, corpo) {
    if (status === 200) {
      if (!corpo || typeof corpo !== 'object') return 'erro';
      if (corpo.inserted >= 1) return 'ok';
      if (corpo.skipped_duplicate_in_campaign >= 1 || corpo.skipped_duplicate_in_request >= 1) return 'duplicado';
      if (corpo.skipped_invalid_phone >= 1) return 'telefone';
      return 'erro';
    }
    if (status === 404) return 'link';
    if (status === 0 || status === 429 || status >= 500) return 'tentar';
    return 'erro';
  }

  function esperar(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  // Uma tentativa e no máximo mais uma (429/5xx/rede/tempo esgotado), depois de `pausaMs`.
  function enviarCrm(url, payload, opcoes) {
    opcoes = opcoes || {};
    var buscar = opcoes.fetch || (typeof fetch === 'function' ? fetch : null);
    var dormir = opcoes.esperar || esperar;
    var limiteMs = opcoes.limiteMs || 8000;
    var pausaMs = typeof opcoes.pausaMs === 'number' ? opcoes.pausaMs : 1500;
    if (!url || !buscar) return Promise.resolve({ resultado: 'sem-link', status: 0, corpo: null, tentativas: 0 });

    function tentar() {
      var controle = typeof AbortController === 'function' ? new AbortController() : null;
      var relogio = setTimeout(function () { if (controle) controle.abort(); }, limiteMs);
      return Promise.resolve()
        .then(function () {
          return buscar(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload),
            credentials: 'omit',
            signal: controle ? controle.signal : undefined
          });
        })
        .then(function (resposta) {
          return resposta.json().catch(function () { return null; }).then(function (corpo) {
            return { status: resposta.status, corpo: corpo };
          });
        }, function () { return { status: 0, corpo: null }; })
        .then(function (r) {
          clearTimeout(relogio);
          return { resultado: classificarResposta(r.status, r.corpo), status: r.status, corpo: r.corpo };
        });
    }

    return tentar().then(function (primeira) {
      if (primeira.resultado !== 'tentar') { primeira.tentativas = 1; return primeira; }
      return dormir(pausaMs).then(tentar).then(function (segunda) {
        segunda.tentativas = 2;
        if (segunda.resultado === 'tentar') segunda.resultado = 'erro';
        return segunda;
      });
    });
  }

  /* ---------- rastreio (sem dado pessoal) ---------- */

  /* Lead no pixel antigo da Meta (12/10): o pixel da loja roda isolado (app Facebook & Instagram) e não
     enxerga este evento. Aqui o pixel só é iniciado na hora do cadastro, sem PageView e sem os eventos
     automáticos, e manda 1 Lead por cadastro novo (o repetido não chega aqui). */
  var PIXEL_META = '1499309390710877';

  function leadMeta(janela) {
    var doc = janela.document;
    if (!doc) return;
    if (typeof janela.fbq !== 'function') {
      var n = janela.fbq = function () {
        if (n.callMethod) n.callMethod.apply(n, arguments); else n.queue.push(arguments);
      };
      if (!janela._fbq) janela._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      var tag = doc.createElement('script');
      tag.async = true;
      tag.src = 'https://connect.facebook.net/en_US/fbevents.js';
      (doc.head || doc.documentElement).appendChild(tag);
    }
    janela.fbq('set', 'autoConfig', false, PIXEL_META);
    janela.fbq('init', PIXEL_META);
    /* trackSingle (16/10): o GTM da loja já inicia o 1499 e o Burst 3 (1547…, descartado em 06/10) no mesmo fbq,
       e o 'track' mandava o Lead pros dois. A captação otimiza Lead no 1499. */
    janela.fbq('trackSingle', PIXEL_META, 'Lead', { content_name: 'lista-vip' });
  }

  function publicarEventos(nomeEvento, origem, alvo) {
    var janela = alvo || raiz;
    try {
      var shopify = janela.Shopify;
      if (shopify && shopify.analytics && typeof shopify.analytics.publish === 'function') {
        shopify.analytics.publish(nomeEvento, { source: origem });
      }
    } catch (e) { /* rastreio nunca derruba o cadastro */ }
    try {
      if (typeof janela.clarity === 'function') janela.clarity('event', nomeEvento);
    } catch (e) { /* idem */ }
    try { leadMeta(janela); } catch (e) { /* idem */ }
  }

  /* ---------- tela ---------- */

  function iniciar(caixa) {
    if (!caixa || caixa.getAttribute('data-bst-pronto') === '1') return;
    var form = caixa.querySelector('[data-bst-form]');
    var botao = caixa.querySelector('[data-bst-enviar]');
    var erroGeral = caixa.querySelector('[data-bst-erro-geral]');
    var sucesso = caixa.querySelector('[data-bst-sucesso]');
    var duplicado = caixa.querySelector('[data-bst-duplicado]');
    var campos = {
      nome: caixa.querySelector('[data-bst-campo="nome"]'),
      email: caixa.querySelector('[data-bst-campo="email"]'),
      whatsapp: caixa.querySelector('[data-bst-campo="whatsapp"]')
    };
    if (!form || !botao || !campos.nome || !campos.email || !campos.whatsapp) return;
    var ordem = ['nome', 'email', 'whatsapp'];
    var textoBotao = botao.textContent;
    var enviando = false;

    function erroCampo(nome, mostrar) {
      var msg = caixa.querySelector('[data-bst-erro-campo="' + nome + '"]');
      campos[nome].setAttribute('aria-invalid', mostrar ? 'true' : 'false');
      if (msg) msg.hidden = !mostrar;
    }

    function validar() {
      var ok = {
        nome: nomeValido(campos.nome.value),
        email: emailValido(campos.email.value),
        whatsapp: normalizarTelefone(campos.whatsapp.value) !== null
      };
      ordem.forEach(function (n) { erroCampo(n, !ok[n]); });
      var invalido = ordem.filter(function (n) { return !ok[n]; })[0];
      if (invalido) campos[invalido].focus();
      return !invalido;
    }

    function travar(sim) {
      enviando = sim;
      botao.disabled = sim;
      botao.textContent = sim ? (botao.getAttribute('data-texto-enviando') || textoBotao) : textoBotao;
    }

    function mostrarEstado(elemento) {
      form.hidden = true;
      if (elemento) {
        elemento.hidden = false;
        try { elemento.focus({ preventScroll: true }); } catch (e) { elemento.focus(); }
      }
    }

    campos.whatsapp.addEventListener('input', function () {
      var formatado = formatarTelefone(campos.whatsapp.value);
      if (formatado !== campos.whatsapp.value) campos.whatsapp.value = formatado;
    });
    ordem.forEach(function (n) {
      campos[n].addEventListener('input', function () {
        if (campos[n].getAttribute('aria-invalid') === 'true') erroCampo(n, false);
        if (erroGeral) erroGeral.hidden = true;
      });
    });

    form.addEventListener('submit', function (evento) {
      evento.preventDefault();
      if (enviando) return;
      if (erroGeral) erroGeral.hidden = true;
      if (!validar()) return;
      var dados = { nome: campos.nome.value, email: campos.email.value, whatsapp: campos.whatsapp.value };
      var config = { origem: caixa.getAttribute('data-origem'), consentimento: caixa.getAttribute('data-consentimento') };
      var payload = montarPayload(dados, config, raiz.location);
      travar(true);

      enviarCrm(caixa.getAttribute('data-crm-url'), payload).then(function (r) {
        if (r.resultado === 'ok') {
          var alvo = sucesso && sucesso.querySelector('[data-bst-nome-alvo]');
          if (alvo) alvo.textContent = primeiroNome(dados.nome);
          mostrarEstado(sucesso);
          publicarEventos(caixa.getAttribute('data-evento') || 'lista_cadastro', config.origem);
          return;
        }
        if (r.resultado === 'duplicado') {
          mostrarEstado(duplicado || sucesso);
          return;
        }
        travar(false);
        if (r.resultado === 'telefone') {
          erroCampo('whatsapp', true);
          campos.whatsapp.focus();
          return;
        }
        if (typeof console !== 'undefined') console.error('Burst lista: envio ao CRM falhou —', r.resultado, 'HTTP', r.status);
        if (erroGeral) erroGeral.hidden = false;
      });
    });

    caixa.setAttribute('data-bst-pronto', '1');
    botao.disabled = false;  // nasce travado no HTML: sem JS, nada de GET com dados pessoais na URL
  }

  function iniciarIrParaLista(doc) {
    if (doc.__bstIrParaLista) return;
    doc.__bstIrParaLista = true;
    doc.addEventListener('click', function (evento) {
      var gatilho = evento.target && evento.target.closest ? evento.target.closest('[data-bst-ir-para-lista]') : null;
      if (!gatilho) return;
      var caixa = doc.querySelector('[data-bst-lista]');
      if (!caixa) return;
      evento.preventDefault();
      caixa.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var form = caixa.querySelector('[data-bst-form]');
      var nome = caixa.querySelector('[data-bst-campo="nome"]');
      if (form && !form.hidden && nome) {
        setTimeout(function () {
          try { nome.focus({ preventScroll: true }); } catch (e) { nome.focus(); }
        }, 450);
      }
    });
  }

  if (typeof document !== 'undefined' && document.querySelectorAll) {
    var iniciarTudo = function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bst-lista]'), iniciar);
      iniciarIrParaLista(document);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarTudo);
    else iniciarTudo();
  }


  return {
    digitosNacionais: digitosNacionais,
    normalizarTelefone: normalizarTelefone,
    formatarTelefone: formatarTelefone,
    emailValido: emailValido,
    nomeValido: nomeValido,
    separarNome: separarNome,
    primeiroNome: primeiroNome,
    lerUtms: lerUtms,
    montarPayload: montarPayload,
    classificarResposta: classificarResposta,
    enviarCrm: enviarCrm,
    publicarEventos: publicarEventos,
    iniciar: iniciar
  };
});
